import Repository from './Repository'
import JSONCities from '@/data/cities.json'
import { countryConfig } from '../country-config/country-config'

export default {
    getCities() {
        if (countryConfig.isColombia) {
            return JSONCities.citiesCol
        } else if (countryConfig.isVenezuela) {
            return JSONCities.citiesVzla
        }
    },
}